module.exports = __webpack_public_path__ + "static/sepsis-demo-b552c8a3775c88bf58e551fe9f27832f.mp4";